import { useQuery } from "@apollo/client";

import { BeneficiaryGiftingLinkQuery, BeneficiaryGiftingLinkQueryVariables } from "@ctypes";
import { BENEFICIARY_GIFTING_LINK } from "@graphql";

export const useBeneficiaryGiftingLink = ({ beneficiaryId }: { beneficiaryId?: string | null }) => {
  const { data: queryData, ...rest } = useQuery<
    BeneficiaryGiftingLinkQuery,
    BeneficiaryGiftingLinkQueryVariables
  >(BENEFICIARY_GIFTING_LINK, {
    variables: { beneficiaryId: beneficiaryId! },
    skip: !beneficiaryId,
  });

  const data = queryData?.beneficiaryGiftingLink;

  return { data, ...rest };
};
